import type { LanguageCode } from 'iso-639-1'

import type { Response } from '~/types/api/v2'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import { type DocumentIdentifier, getUrlById as getDocumentByIdUrl } from '../useFetchDocument'

export const useFetchDocumentLanguage = () => {
  const getUrl = (documentId: string) => `${getDocumentByIdUrl(documentId)}/languages`

  const update = ({
    workspaceId,
    documentId,
    languageCodes,
  }: DocumentIdentifier & { languageCodes: LanguageCode[] }) => {
    const { put } = useFetchWithDefaults()

    const body: App.Data.Payloads.Documents.UpdateLanguagesPayload = {
      languages: languageCodes,
    }

    return put<Response<App.Data.Document.Metadata.LanguageData[]>>({
      url: getUrl(documentId),
      workspaceId,
      fetchOptions: {
        body,
      },
    })
  }

  return {
    update,
  }
}
